// test1234
(1234 && 0);
